import type { FC } from 'react';
import React, { useContext } from 'react';
import { Tick } from '@youlify/icons';

import Button from '../../button';
import { convertLegacyProps } from '../../button/buttonHelpers';
import { ModalContext } from '../context';
import type { ModalProps } from '../interface';

export interface NormalOkBtnProps
  extends Pick<ModalProps, 'confirmLoading' | 'okType' | 'okButtonProps' | 'onOk'> {
  okTextLocale?: React.ReactNode;
}

const NormalOkBtn: FC = () => {
  const { confirmLoading, okButtonProps, okType, okTextLocale, onOk } = useContext(ModalContext);
  return (
    <Button
      {...convertLegacyProps(okType)}
      loading={confirmLoading}
      icon={<Tick />}
      onClick={onOk}
      {...okButtonProps}
    >
      {okTextLocale}
    </Button>
  );
};

export default NormalOkBtn;
